export default function * success () {
  // yield navigate(ROUTES.DonorDashboard)
}
